import { Moment } from 'moment';
import { QuestResponseType } from '../Quotation/Quotation.types';

export enum QuestCostReportType {
  costPerPartSales = 'CostPerPartSales',
  fixedCost = 'FixedCost',
  variableCost = 'VariableCost',
  overallCost = 'OverallCost',
}

export enum QuestCostWorkOrderTypes {
  courtesy = 'domain.enums.work_order_type.courtesy',
  warranty = 'domain.enums.work_order_type.warranty',
  workOrder = 'domain.enums.work_order_type.work_order',
  totalLoss = 'domain.enums.work_order_type.total_loss',
  return = 'domain.enums.work_order_type.return',
  revision = 'domain.enums.work_order_type.revision',
}

export enum QuestCostDateFilter {
  emissionDate = 'EmissionDate',
  dueDate = 'DueDate',
  payDate = 'PayDate',
}

export enum QuestCostSituationType {
  open = 'OPEN',
  liquidated = 'LIQUIDATED',
}

export interface QuestCostRequest {
  responseType: QuestResponseType;
  companiesIds?: string;
  reportType: QuestCostReportType;
  workOrderTypes?: QuestCostWorkOrderTypes[];
  situationOpen?: boolean;
  situationSettled?: boolean;
  dateFilter?: QuestCostDateFilter;
  startDate: string;
  endDate: string;
}

export interface QuestCostFormValues {
  companiesIds?: number[];
  reportType: QuestCostReportType;
  workOrderTypes?: QuestCostWorkOrderTypes[];
  situation?: QuestCostSituationType;
  initialDate: Moment;
  finalDate: Moment;
}
